export const NAV_CATEGORIES = [
  'watches',
  'eyewear',
  'eyeglasses',
  'perfume',
  'knives',
  'presents',
];

export const FILTER_GENDERS = ['Man', 'Woman', 'Unisex'];

export const FILTER_MATERIALS = [
  'Stainless Steel',
  'Carbon Steel',
  'Ceramic',
];

const formatPrescription = (value) => {
  const sign = value > 0 ? '+' : '-';
  return `${sign}${Math.abs(value).toFixed(2)}`;
};

const buildPrescriptionRange = (sign) => [
  ...Array.from({ length: 20 }, (_, index) => formatPrescription(sign * ((index + 1) * 0.25))),
  ...[6, 7, 8].map((value) => formatPrescription(sign * value)),
];

export const EYEGLASSES_PRESCRIPTION_OPTIONS = [
  ...buildPrescriptionRange(-1),
  ...buildPrescriptionRange(1),
];

export const PRESENT_TYPE_OPTIONS = [
  { value: 'knife', label: 'Knife', labelKey: 'catalog.presentType.knife' },
  { value: 'lighter', label: 'Lighter', labelKey: 'catalog.presentType.lighter' },
  { value: 'binoculars', label: 'Binoculars', labelKey: 'catalog.presentType.binoculars' },
  { value: 'jewelry', label: 'Jewelry', labelKey: 'catalog.presentType.jewelry' },
];
